var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"influx-line-wrapper"},[_c('e-chart',{attrs:{"options":_vm.optionsC,"theme":"light"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }